import { getTeamPage, getGlobals } from "storyblok/api"
import Meta from "components/Meta"
import TeamPage from "components/DynamicComponent/organisms/TeamPage"

export default function Team({ meta, story }) {
  return (
    <>
      <Meta info={meta} />
      <TeamPage story={story} />
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()
  const story = await getTeamPage(preview)

  return {
    props: {
      story: story ?? null,
      meta: story?.page?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
